import { PanicButtonTimer } from '../../containers/PanicButton/panicButtonTimer';

function PanicAlarmTimerPage() {
  return <PanicButtonTimer />;
}

export default PanicAlarmTimerPage;
